import { TraverseJoint } from './traverse-joint.js';

const GetAllJoints = (joint) => {
    const joints = new Set();
    const callback = (j) => {
        joints.add(j);
    };
    TraverseJoint(joint, [], callback);
    return Array.from(joints);
};

export { GetAllJoints };
//# sourceMappingURL=get-all-joints.js.map
